var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 28,
    viewBox: "0 0 30 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.33398 3.33366H21.6673C24.6128 3.33366 27.0006 5.72147 27.0006 8.66699V19.3337C27.0006 22.2792 24.6128 24.667 21.6673 24.667H8.33398C5.38847 24.667 3.00065 22.2792 3.00065 19.3337V8.66699C3.00065 5.72147 5.38847 3.33366 8.33398 3.33366ZM0.333984 8.66699C0.333984 4.24871 3.91571 0.666992 8.33398 0.666992H21.6673C26.0856 0.666992 29.6673 4.24871 29.6673 8.66699V19.3337C29.6673 23.7519 26.0856 27.3337 21.6673 27.3337H8.33398C3.91571 27.3337 0.333984 23.7519 0.333984 19.3337V8.66699ZM7.74039 8.22424C7.12769 7.81577 6.29986 7.98133 5.89139 8.59404C5.48292 9.20674 5.64849 10.0346 6.26119 10.443L12.782 14.7902C14.1256 15.686 15.876 15.686 17.2196 14.7902L23.7404 10.443C24.3531 10.0346 24.5187 9.20674 24.1102 8.59404C23.7017 7.98133 22.8739 7.81577 22.2612 8.22424L15.7404 12.5714C15.2925 12.87 14.7091 12.87 14.2612 12.5714L7.74039 8.22424Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEmail);
export default __webpack_public_path__ + "static/media/ic_email.096710d00b4795de213df6e6752e7216.svg";
export { ForwardRef as ReactComponent };